import React from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { AgentDriftHero } from '../components/agent-drift/AgentDriftHero';
import { FourTellsSection } from '../components/agent-drift/FourTellsSection';
import { ConstitutionSection } from '../components/agent-drift/ConstitutionSection';
import { AgentPipelineSection } from '../components/agent-drift/AgentPipelineSection';
import { AgentDriftCTA } from '../components/agent-drift/AgentDriftCTA';
export function AgentDriftPage() {
  return <div className="min-h-screen w-full bg-white selection:bg-[#0066FF] selection:text-white" data-id="element-1333">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-1334">
        <div className="w-full px-6 md:px-12 lg:px-24" data-id="element-1335">
          <div className="max-w-7xl mx-auto h-20 flex items-center" data-id="element-1336">
            <Link to="/" data-id="element-1337">
              <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8" data-id="element-1338" />
            </Link>
            <Navigation data-id="element-1339" />
          </div>
        </div>
      </header>

      <main data-id="element-1340">
        <AgentDriftHero data-id="element-1341" />
        <FourTellsSection data-id="element-1342" />
        <ConstitutionSection data-id="element-1343" />
        <AgentPipelineSection data-id="element-1344" />
        <AgentDriftCTA data-id="element-1345" />
      </main>

      <Footer data-id="element-1346" />
    </div>;
}